/**
 * Phase 1 Geiss-flavoured preset pack. Order matters: this is the order
 * arrow keys / number-row hotkeys cycle through.
 *
 * Slot ordering:
 *   1 → `auto`              the auto-DJ (default boot preset). Drives the
 *                           AutoCycler, which sequences the rest based on
 *                           time + beat + energy. This is the Geiss feel.
 *   2 → `phase0_reference`  pinned anti-regression baseline.
 *   3..N → polished children, in roughly increasing visual intensity.
 *
 * The auto preset is registered like any other (so slots / arrows / random
 * work uniformly) but the engine intercepts it and swaps to a real child
 * before rendering.
 */

import type { VisualizerPreset } from '../presetTypes';
import { autoPreset } from './auto';
import { phase0ReferencePreset } from './phase0Reference';
import { radialBloomPreset } from './radialBloom';
import { spiralDriftPreset } from './spiralDrift';
import { sinPulsePreset } from './sinPulse';
import { bassWellPreset } from './bassWell';
import { curlFlowPreset } from './curlFlow';
import { spiralOrbitPreset } from './spiralOrbit';
import { mandalaPreset } from './mandala';
import { fractalDriftPreset } from './fractalDrift';

/**
 * Children the AutoCycler is allowed to choose between. We deliberately
 * exclude `auto` (would recurse) and `phase0_reference` (the regression
 * baseline is intentionally less dynamic than the other presets and
 * doesn't fit the auto-DJ vibe).
 */
export const AUTO_CYCLER_CHILDREN = [
  radialBloomPreset.id,
  spiralDriftPreset.id,
  sinPulsePreset.id,
  bassWellPreset.id,
  curlFlowPreset.id,
  spiralOrbitPreset.id,
  mandalaPreset.id,
  fractalDriftPreset.id,
] as const;

export const geissPresets: VisualizerPreset[] = [
  autoPreset,
  phase0ReferencePreset,
  radialBloomPreset,
  spiralDriftPreset,
  sinPulsePreset,
  bassWellPreset,
  curlFlowPreset,
  spiralOrbitPreset,
  mandalaPreset,
  fractalDriftPreset,
];
